export const hasForm = (formsById) => (formId) => Boolean(formsById[formId]);
//# sourceMappingURL=has-form.js.map